import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { PirsaDeliveryList } from "./PirsaDeliveryList";

export default {
  list: PirsaDeliveryList,
  icon: LocalShippingIcon,
  label: "Pirsa delivery",
  options: { label: "Pirsa delivery" },
  name: "niyaazPirsa",
};
